export enum BankIdAuthQueries {
  AutoStartToken = 'autostarttoken',
  Redirect = 'redirect',
  Language = 'lang',
}